import {
  GetEventChannelResponse,
  InAppNotificationPerTargetIdResponse,
} from "@shared/types/common";
import apiProxy from "@shared/utils/api-proxy";
import { useInAppNotificationsStore } from "@shared/stores/inAppNotificationsStore.ts";

export const inAppNotificationsService = {
  getEventChannel: async () => {
    const response: GetEventChannelResponse | null = await apiProxy.get(
      `in-app-notifications/event-channel`,
    );
    if (!response) {
      throw new Error("Got no response from server");
    }
    return response;
  },

  load2WeeksOldInAppNotifications: async (
    startDate: number,
    endDate: number,
  ) => {
    const response: InAppNotificationPerTargetIdResponse | null =
      await apiProxy.get(
        `in-app-notifications/list?startDate=${startDate}&endDate=${endDate}`,
      );

    if (!response) {
      throw new Error("Got no inApp notifications response from server");
    }
    const flattedItems = response.items.flatMap(
      (item) => item.inAppNotifications,
    );
    useInAppNotificationsStore().setInAppNotifications(flattedItems);
  },
};
